import React, { useState } from "react";
import { FaBars, FaTimes} from "react-icons/fa";
import { Link } from "react-router-dom";


export default function Header(props) {
    const[mobileNav, setMobileNav]= useState(false);
    const handleToggle = () =>{
    setMobileNav(!mobileNav);
    }
   

    return (
        <div className="header">
            <div className="logo" >
            <div class="material-symbols-outlined bullet">square</div>
            <h2 className="logo-name"><Link to="/" > {props.name}
                <br/><span className="logo-title">{props.title}</span></Link>
            </h2>
            </div>
        <div>
            <ul className="nav">
                <li><Link to= "/" >ABOUT ME</Link></li>
                <li><Link to= "/projects">PROJECTS</Link></li>
                <li> <Link to="/blog">BLOG</Link></li>
                <li><Link to= "/contact"> CONTACT</Link></li>
            </ul>
            
            <div>
            <div className="hamburger-menu" onClick={handleToggle}>
            {!mobileNav ? <FaBars /> : <FaTimes />} 
            </div>
            <ul className={!mobileNav? "hidden": "mobilenav"}>
                <li><Link to= "/" onClick={handleToggle}>ABOUT ME</Link></li>
                <li><Link to= "/projects" onClick={handleToggle}> PROJECTS</Link></li>
                <li><Link to= "/blog" onClick={handleToggle}> BLOG</Link></li>
                <li><Link to= "/contact" onClick={handleToggle}> CONTACT</Link></li>
         
            </ul>
                
            </div>
        </div>
        </div>
    )
}